import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updateOrganizationExecutablesUrl } from "../../../config";
import api from "../../../api";
import { Status } from "../../../common/constants";
import { RootState } from "../../../store";
import { IInitialFirmwareVersionSliceState, IStatusError } from "../../../common/types/commonTypes";
const UPDATE_IOT_AGENT_VERSION: string = "updateIotAgentVersion";
const initialState: IInitialFirmwareVersionSliceState = {
    msg: "",
    orgId: "",
    show: false,
    status: Status.IDLE,
    error: null,
};

export interface IUpdateResponse extends IStatusError {
    message: string | null;
}

interface IUpdatePayload {
    orgId: string;
    fileName: string;
    fileType: string;
    version: string;
}

export const updateIotAgentVersion = createAsyncThunk(
    UPDATE_IOT_AGENT_VERSION,
    async (payload: IUpdatePayload, { rejectWithValue }) => {
        try {
            const response = await api.post<IUpdateResponse>(
                updateOrganizationExecutablesUrl,
                payload
            );
            const updateResponse: IUpdateResponse = response.data;
            return updateResponse;
        } catch (error) {
            throw rejectWithValue(error);
        }
    }
);

const updateIotAgentVersionSlice = createSlice({
    name: UPDATE_IOT_AGENT_VERSION,
    initialState,
    reducers: {
        setShow: (state, action) => {
            state.show = action.payload;
        },
        setOrgId: (state, action) => {
            state.orgId = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateIotAgentVersion.pending, (state) => {
                state.status = Status.PENDING;
                state.msg = "";
            })
            .addCase(updateIotAgentVersion.fulfilled, (state) => {
                state.msg = "Updated Successfully";
                state.status = Status.SUCCESS;
            })
            .addCase(updateIotAgentVersion.rejected, (state, action) => {
                const errorPayload = action.payload as {
                    response?: {
                        data?: { error?: { message?: string }; message?: string };
                    };
                };
                state.msg =
                    errorPayload.response?.data?.error?.message ||
                    errorPayload.response?.data?.message ||
                    "Error occurred while updating";
                state.status = Status.FAILED;
            });
    },
});


type Selector = {
    updateOrganizationFirmwareVersion: ReturnType<typeof updateIotAgentVersionSlice.reducer>;
};
export const reducer = updateIotAgentVersionSlice.reducer;
export const { setShow, setOrgId } = updateIotAgentVersionSlice.actions;
export const selector = (store: Selector) => store["updateOrganizationIotAgentVersion"];
